import * as $ from 'jquery';
import SelectAddable from './select-addable';

var TrainerSelect = function($select, value)
{
    this.saveInstance();
    this.$select = $select;
    this.value = value;
    this.$button = $select.closest('.input-group').find('button.trainer-create-button');
    this.$container = $select.closest('div.form-group');
    this.$modal = this.$container.find('div.modal');

    this.setup();
};

TrainerSelect.prototype.saveInstance = function()
{
    if (!window.Instances) window.Instances = [];
    if (!window.Instances.Trainers) window.Instances.Trainers = [];
    window.Instances.Trainers.push(this);
};

TrainerSelect.prototype.setup = function()
{
    // Save all data
    if (!window.Trainers || window.Trainers.length === 0)
    {
        window.Trainers = [];

        // Save all Trainer data
        this.$select.find('option').each(function() {
            window.Trainers.push({
                id: $(this).val(),
                name: $(this).html()
            });
        });

        // See if we have any trainers, if not... let's do an ajax request
        if (window.Trainers.length === 0 && !TrainerSelect.running)
        {
            TrainerSelect.running = true;

            var self = this;
            $.ajax('/trainers/ajax/', {
                method: 'GET',
                success: function(data)
                {
                    $.each(data, function(idx, item) {
                        // TODO: Check if the object doesn't already exists
                        window.Trainers.push({
                            id: item.id,
                            name: item.first_name + ' ' + item.last_name
                        });
                    });

                    // Sort the Trainers by name
                    window.Trainers.sort(function ( a, b ) {
                        if ( a.name < b.name ){
                            return -1;
                        }
                        if ( a.name > b.name ){
                            return 1;
                        }
                        return 0;
                    });

                    window.Trainers.unshift({
                        id: '',
                        name: 'Pick a trainer'
                    });

                    // Fill the selects for all instances
                    $.each(window.Instances.Trainers, function(idx, instance) {

                        if (instance.$select.find('option').length === 0)
                        {
                            $.each(window.Trainers, function(idx, item) {
                                var $option = $('<option>', { value: item.id });
                                $option.html(item.name);
                                instance.$select.append($option);
                            });

                            instance.$select.selectpicker('refresh');
                        }
                    });

                },
                complete: function()
                {
                    TrainerSelect.running = false;

                }
            });
        }

    }

    if (this.$modal.length === 0 && !TrainerSelect.rendering)
    {
        TrainerSelect.rendering = true;

        if (window.Modals && window.Modals.Trainers && window.Modals.Trainers.Add)
        {
            this.setupModal(window.Modals.Trainers.Add.clone());
            TrainerSelect.rendering = false;
        } else
        {
            $.ajax('/trainers/ajax/modals/add', {
                method: 'GET',
                success: function(html)
                {
                    if (!window.Modals) window.Modals = [];
                    if (!window.Modals.Trainers) window.Modals.Trainers = [];
                    window.Modals.Trainers.Add = $(html);

                    $.each(window.Instances.Trainers, function(idx, instance) {
                        if (instance.$modal.length === 0)
                        {
                            instance.setupModal(window.Modals.Trainers.Add.clone());
                        }
                    });
                },
                completed: function()
                {
                    TrainerSelect.rendering = false;
                }
            });
        }
    } else if (!TrainerSelect.rendering)
    {
        if (!window.Modals) window.Modals = [];
        if (!window.Modals.Trainers) window.Modals.Trainers = [];
        window.Modals.Trainers.Add = this.$modal;
        this.setupAddable();
    }
};

TrainerSelect.prototype.setupModal = function($modal)
{
    var $foundModal = this.$container.find('div.modal');
    if ($foundModal.length === 0)
    {
        this.$modal = $modal;
        this.$container.append($modal);
    } else
    {
        this.$modal = $foundModal;
    }
    this.setupAddable();
};

TrainerSelect.prototype.setupAddable = function()
{
    // Setup button functionality
    this.button_instance = new SelectAddable(
        this.$button,
        'fluffy-control-trainer',
        function(data) { return data.name; },
        function(data) { return data.id; }
    );
};

TrainerSelect.prototype.create = function()
{
    if (window.Trainers)
    {
        this.$select.empty();
        var self = this;

        // Fill the select
        $.each(window.Trainers, function(idx, item) {
            var $option = $('<option>', { value: item.id });
            $option.html(item.name);
            self.$select.append($option);
        });

        // Create input group
        var $inputGroup = $('<div/>', {class: 'input-group'});
        this.$select.wrap($inputGroup);

        // Add the button
        this.$inputGroupAppend = $('<div class="input-group-append"></div>');
        this.$button = $('<button class="btn btn-primary trainer-create-button"><i class="fa fa-plus"></i></button>');
        this.$inputGroupAppend.append(this.$button);
        this.$select.after( this.$inputGroupAppend );

        // Make it a select picker
        this.$select.data({
            container: 'body',
            'show-subtext': true,
            'live-search': true
        });
        this.$select.addClass('form-control selectpicker show-tick fluffy-control-trainer');

        if (this.value) this.$select.val(this.value);

        this.$select.selectpicker();

        // Add the button functionality
        setTimeout(function() { self.setup(); }, 10);
    } else
    {
        console.log('No trainers found yet');
    }
};

export default TrainerSelect;